export var BogTransactionStatusEnum;
(function (BogTransactionStatusEnum) {
    BogTransactionStatusEnum["FINALIZED"] = "FINALIZED";
    BogTransactionStatusEnum["INCOMPLETE"] = "INCOMPLETE";
    BogTransactionStatusEnum["CONFLICTING"] = "CONFLICTING";
    BogTransactionStatusEnum["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
})(BogTransactionStatusEnum || (BogTransactionStatusEnum = {}));
//# sourceMappingURL=bog-transaction-status.enum.js.map